import * as req from 'api/actions';
import * as c from './constant';

export const getPensionList = (payload, callback) =>
  req.list(
    c.GET_PENSIONS,
    'api/v1/administrators/social_amelioration_citizens/settings/pensions',
    payload,
    callback
  );

export const showPension = (id, payload, callback) =>
  req.item(
    c.SHOW_PENSION,
    `api/v1/administrators/social_amelioration_citizens/settings/pensions/${id}`,
    payload,
    callback
  );

export const updatePension = (id, payload, callback) =>
  req.update(
    c.UPDATE_PENSION,
    `api/v1/administrators/social_amelioration_citizens/settings/pensions/${id}`,
    payload,
    ({ res }) => {
      const { data } = res.res;
      if (callback) callback({ data });
    }
  );

export const clearPension = () => req.setList(c.GET_PENSIONS, []);

export const createPension = (payload, callback) =>
  req.create(
    c.CREATE_PENSION,
    `api/v1/administrators/social_amelioration_citizens/settings/pensions`,
    payload,
    ({ res }) => {
      const { data } = res.res;
      if (callback) callback({ data });
    }
  );

export const removePension = (id, payload, callback) =>
  req.remove(
    c.REMOVE_PENSION,
    `api/v1/administrators/social_amelioration_citizens/settings/pensions/${id}`,
    payload,
    (res) => {
      const { message } = res.res;
      alert.success(message || 'Successfully Remove !');
      if (callback) callback();
    }
  );
